import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback } from "react";
import { jsxJoin } from "@devowl-wp/react-utils";
import { FooterLink } from "../../components/common/footer/link.js";
import { FooterPoweredByLink } from "../../components/common/footer/poweredByLink.js";
import { useBannerOrBlocker } from "../useBannerOrBlocker.js";
function useCommonFooterLinks(param) {
    let { onClose, putPoweredByLinkInRow, row1, row1End } = param === void 0 ? {} : param;
    const { i18n: { close }, footerDesign: { poweredByLink }, poweredLink, links = [], affiliate } = useBannerOrBlocker();
    const targetBlankAttributes = {
        target: "_blank",
        rel: "noopener"
    };
    const rows = [
        // Row 1
        [
            onClose && /*#__PURE__*/ _jsx(FooterLink, {
                href: "#",
                onClick: onClose,
                "interaction-player-skip": "1",
                children: /*#__PURE__*/ _jsx("strong", {
                    children: close
                })
            }, "close"),
            ...row1 || [],
            ...links.map((param, i)=>{
                let { label, url, isTargetBlank } = param;
                return !!label && !!url && /*#__PURE__*/ _jsx(FooterLink, {
                    href: url,
                    ...isTargetBlank === undefined || isTargetBlank ? targetBlankAttributes : {},
                    children: label
                }, `${i.toString()}-links`);
            }),
            ...row1End || []
        ].filter(Boolean),
        // Row 2
        []
    ];
    if (!!poweredLink && poweredByLink) {
        rows[putPoweredByLinkInRow || 0].push(/*#__PURE__*/ _jsx(FooterPoweredByLink, {
            poweredLink: poweredLink,
            affiliate: affiliate
        }, "poweredBy"));
    }
    const render = useCallback((rows)=>jsxJoin(rows.map((row)=>row.length ? /*#__PURE__*/ _jsx(Fragment, {
                children: jsxJoin(row, /*#__PURE__*/ _jsx(Fragment, {
                    children: " • "
                }))
            }, row[0].key) : null), /*#__PURE__*/ _jsx("br", {
            "aria-hidden": true
        })), []);
    return {
        rows,
        render
    };
}
export { useCommonFooterLinks };
